<template>
    <div class="AddNewCareCommunity">
        <b-form class="full-width" @submit="AddNewCareCommunity">
            <b-row>
                <b-col lg="12">
                    <h2>Care Community Information</h2>
                    <b-form-group label="Name:">
                        <b-form-input type="text"
                                      v-model="CareCommunity.Name"
                                      required
                                      autocomplete="off" />
                    </b-form-group>
                    <b-form-group label="Team Leader Name:">
                        <b-form-input type="text"
                                      v-model="CareCommunity.TeamLeaderName"
                                      required
                                      autocomplete="off" />
                    </b-form-group>
                    <b-form-group label="Team Leader Email:">
                        <b-form-input type="text"
                                      v-model="CareCommunity.TeamLeaderEmail"
                                      required
                                      autocomplete="off" />
                    </b-form-group>
                    <b-row>
                        <b-col>
                            <b-form-group label="Team Leader Phone Number:">
                                <b-form-input type="text"
                                              v-model="CareCommunity.TeamLeaderPhoneNumber"
                                              required
                                              autocomplete="off" />
                            </b-form-group>
                        </b-col>
                    </b-row>
                     <b-form-group label="Region:">
                        <select class="form-control" v-model="CareCommunity.Region" required>
                            <option value="">Select Region</option>
                            <option v-for="option in SubProgramRegionOptions" :value="option.value">
                                {{option.text}}
                            </option>
                        </select>
                     </b-form-group>
                    <b-form-group label="Address:">
                        <b-row>
                            <b-col cols="8">
                                <b-form-input type="text"
                                              v-model="CareCommunity.Address.AddressLine1"
                                              required
                                              autocomplete="off"
                                              placeholder="Street Address" />
                            </b-col>
                            <b-col cols="4">
                                <b-form-input type="text"
                                              v-model="CareCommunity.Address.AddressLine2"
                                              autocomplete="off"
                                              placeholder="Apt, suite, unit, building, floor, etc." />
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <b-form-input type="text"
                                              v-model="CareCommunity.Address.City"
                                              required
                                              autocomplete="off"
                                              placeholder="City" />
                            </b-col>
                            <b-col>
                                <select class="form-control" v-model="CareCommunity.Address.StateAbbreviation" required>
                                    <option value="">Select State</option>
                                    <option v-for="option in StateOptions" :value="option.value">
                                        {{option.text}}
                                    </option>
                                </select>
                            </b-col>
                            <b-col>
                                <b-form-input type="text"
                                              v-model="CareCommunity.Address.ZipCode"
                                              required
                                              autocomplete="off"
                                              placeholder="Zip" />
                            </b-col>
                        </b-row>

                        <select class="form-control" v-model="CareCommunity.Address.County" required>
                            <option value="">Select County</option>
                            <option v-for="option in CountyOptions" :value="option.value">
                                {{option.text}}
                            </option>
                        </select>
                    </b-form-group>
                </b-col>
            </b-row>
            <button class="btn btn-success form-control" type="submit">
                <i class="fa fa-plus"></i> Add Care Community
            </button>
        </b-form>
    </div>
</template>

<script>
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faSearch } from '@fortawesome/free-solid-svg-icons';
    library.add(faSearch);
    import { faRedo } from '@fortawesome/free-solid-svg-icons';
    library.add(faRedo);
    import { faRobot } from '@fortawesome/free-solid-svg-icons';
    library.add(faRobot);
    import { faPlus } from '@fortawesome/free-solid-svg-icons';
    library.add(faPlus);
    import { faMinus } from '@fortawesome/free-solid-svg-icons';
    library.add(faMinus);
    //import components
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';

    import { EventBus } from '../../../services/event-bus.js';
    export default {
        name: "AddNewCareCommunity",
        data: function () {
            return {
                PageState: "Initial",
                
                CareCommunity: {
                    Name: '',
                    TeamLeaderName: '',
                    TeamLeaderPhoneNumber: '',
                    TeamLeaderEmail: '',
                    Region: '',
                    Address: {
                        Name: '',
                        AddressLine1: '',
                        AddressLine2: '',
                        County: '',
                        City: '',
                        State: '',
                        Zip: ''
                    },
                },
                DateConfig: {
                    dateFormat: 'm/d/Y',
                    allowInput: true,
                    required: true
                },
            };
        },
        methods: {
            AddNewCareCommunity(e) {
                e.preventDefault();
                this.$MasterAPI.ExecuteRequest("POST", "Foster/CareCommunity/CareCommunity", this.CareCommunity, this.AddNewCareCommunitySuccess, this.AddLocationError, true);
            },
            AddNewCareCommunitySuccess(response) {
                this.$parent.ChangePaneShown("CareCommunityList");
                // execute global update
                this.$GlobalUpdate.ExecuteGlobalUpdate();
                // Starts a new search. Hides add to progam form and show search client form
                this.ResetPage();
            },
            AddLocationError(error) {
                console.log("Location was not created")
                console.log(error);
            },
            ResetPage() {
                this.$set(this, 'CareCommunity', {
                    Name: '',
                    TeamLeaderName: '',
                    TeamLeaderPhoneNumber: '',
                    TeamLeaderEmail: '',
                    Region: '',
                    Address:{
                        Name: '',
                        AddressLine1: '',
                        AddressLine2: '',
                        County: '',
                        City: '',
                        State: '',
                        Zip: ''
                    },
                });
            },
            formatDate(value, fmt = 'D MMM YYYY') {
                return (value == null)
                    ? ''
                    : moment(value, 'YYYY-MM-DD').format(fmt)
            }
        },
        components: {
            flatPickr,
        },
        computed: {
            CountyOptions: function () {
                return this.$store.state.Options.CaliforniaCounties;
            },
            StateOptions: function () {
                return this.$store.state.Options.USStateAbbreviations;
            },
            ProgramRegions: function () {
                return this.$store.state.Options.ProgramRegions;
            },
            SubProgramOptions: function () {
                return this.$store.getters["User.PrivateProfile.SubPrograms.GetSubProgramOptions"]();
            },
            SubProgramRegionOptions: function () {
                return this.$store.getters["User.PrivateProfile.SubPrograms.GetSubProgramRegionOptions"]();
            },
        }
    }
</script>

<style scoped>
</style>